module.exports = __webpack_public_path__ + "static/media/wincanton-logo-charcoal.32243b92.svg";